const ExchangeRoute = authentication => {
  return [
    // User group route
    // Dash Board Exchange Routes
    {
      path: "/exchangeDash",
      name: "exchangeDash",
      meta: { name: "Exchange" },
      beforeEnter: authentication,
      component: () => import("@/views/Branches/exchange/DashExchange.vue"),
    },

    // Exchange General Report
    {
      path: "/exchangeReport",
      name: "exchangeRep",
      meta: { name: "Exchange Report" },
      beforeEnter: authentication,
      component: () => import("@/views/Branches/exchange/exchangeReport.vue"),
    },
    // USD only Exchange Report
    {
      path: "/usdReport",
      name: "usdReport",
      meta: { name: "USD Report" },
      beforeEnter: authentication,
      component: () => import("@/views/Branches/exchange/USDReport.vue"),
    },
  ];
};

export default ExchangeRoute;
